const infoCards = [

    {
        nombreCard: [""],
        listadoBeneficios: [
            "Gestión del trámite de Reprocann.",
            "Consulta médica.",
            "Acompañamiento en el trámite hasta obtener el permiso.",
            "Posibilidad de cultivo de hasta 9 plantas. (Ver ley completa)",
            "Transporta hasta 40 gramos. (Ver ley completa)",
            "Transporta hasta 6 goteros. (Ver ley completa)"
        ]
    }

];

export default infoCards;